import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/AssetCategoryController/CreateAssetCategoryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateUser({ asset, onClose, onSuccess }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const [formData, setFormData] = useState({ AssetCategory: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (asset) {
            setFormData({ AssetCategory: asset.AssetCategory });
        } else {
            setFormData({ AssetCategory: '' }); // Clear form data when switching to add mode
        }
    }, [asset]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (asset) {
            formData.ID = asset.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="assetCategoryModal" tabIndex="-1" aria-labelledby="assetCategoryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{asset ? "Edit Asset Category" : "Add Asset Category"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">{t('Asset Category')}:</label> {/* Utilize translation for the label */}
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="AssetCategory" value={formData.AssetCategory} onChange={handleFieldChange} />
                                        {errors.AssetCategory && <div style={{ color: 'red' }}>{errors.AssetCategory}</div>}
                                    </div>
                                </div>


                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true">  {asset ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateUser;
